
const FormError = ({ errors, name }) => {
    if (errors.length < 1) {
        return (
            <div className="text-sm">
                <br />
            </div>
        );
    }

    let search = errors.filter(error => (error.inputName === name || error.input === name) && (error.status === true || error.state === true));
    
    if (search.length < 1) {
        // return (
        //     <div className="text-sm">
        //         <br />
        //     </div>
        // );
        return null;
    }

    let item = search[0];

    return (
        <div className="text-md text-red-500 dark:text-red-500">
            {item.message}
        </div>
    );
};

export default FormError;
